module.exports = __webpack_public_path__ + "static/media/alcatel-lucent-logo.d463270d.svg";